import OwlCarousel from "react-owl-carousel";

import { useContext } from "react";
import Title from "../Title/Title";
import "./AppScreens.css";
import { LangContext } from "../../../Context/LangContext";
import "./AppScreens.css";
export default function AppScreens() {
  const langCtx = useContext(LangContext);

  function ItemsSlider(props) {
    return (
      <div className="sub-screen-apps">
        <img src={props.img} alt={props.name} />
      </div>
    );
  }
  return (
    <section className="screen-apps pg-section">
      <div className="main-container">
        <Title name={text.titleAppScreens[langCtx]} center />

        <OwlCarousel
          key={langCtx}
          dir="ltr"
          className="owl-theme mt-5"
          items={5}
          loop
          autoplayHoverPause
          autoplay={false}
          dots={true}
          center
          margin={10}
      
          responsive={{
            300: {
              items: 1,
            },
            568: {
              items: 2,
            },
            768: {
              items: 2,
            },
            992: {
              items: 5,
            },
          }}
        >
          <ItemsSlider key={1} img="/images/screen1.png" />
          <ItemsSlider key={2} img="/images/screen2.png" />
          <ItemsSlider key={3} img="/images/screen3.png" />
          <ItemsSlider key={4} img="/images/screen4.png" />
          <ItemsSlider key={5} img="/images/screen5.png" />
          <ItemsSlider key={6} img="/images/screen5.png" />
        </OwlCarousel>
      </div>
    </section>
  );
}

const text = {
  titleAppScreens: {
    ar: "شاشات التطبيق ",
    en: "Application screens",
  },
};
